export const oddsFormat = (odds: number): string => {
	if (typeof odds !== 'number') return '';
	const decimals = odds < 10 ? 2 : odds < 100 ? 1 : 0;
	return odds.toFixed(decimals);
};
